import React from 'react';
import { Button } from 'flowbite-react';
import { Question, AnswerOption } from 'sched';
import DependencyViewer from '../dependencies/DependencyViewer';
import { useDatabase } from '../../hooks/useDatabase';
import DependenciesTable from '../dependencies/DependenciesTable';

interface OrphanQuestionProps {
    question: Question;
    onAnswerSelected: (option: AnswerOption) => void;
}

const OrphanQuestion: React.FC<OrphanQuestionProps> = ({ question, onAnswerSelected }) => {
    const { database } = useDatabase();

    // Type guard to ensure we're dealing with an orphan question
    if (question.decision.type !== "ResolveOrphan") {
        return <div>Invalid question type: expected ResolveOrphan question</div>;
    }

    const { node_id } = question.decision;

    // Get node details from database if available
    // TODO actually render it as a card
    const nodeTitle = React.useMemo(() => {
        if (!database) return "Unknown Node";

        const tasks = database.tasks();
        // @ts-ignore
        if (node_id.Task) {
            // @ts-ignore
            return tasks[node_id.Task].title();
        }

        const outcomes = database.outcomes();
        // @ts-ignore
        if (outcomes[node_id.Outcome]) {
            // @ts-ignore
            return outcomes[node_id.Outcome].title();
        }

        return "Orphaned Node";
    }, [database, node_id]);

    return (
        <div>
            <h2 className="text-xl font-bold mb-4">Resolve Orphaned Node</h2>

            <div className="mb-4">
                {/* TODO render it as a card */}
                <h3 className="text-lg font-semibold mb-2">{nodeTitle}</h3>
                <p className="text-cm-text-secondary mb-2">
                    This node has no dependencies or dependents. What would you like to do with it?
                </p>
            </div>

            {question.decision.include_completion_option &&
                <>
                    <Button
                        color="green"
                        className="w-full"
                        onClick={() => onAnswerSelected({ MarkComplete: { node: node_id } })}
                    >
                        Mark Complete
                    </Button>
                    <hr className="my-4" /></>
            }

            {/* Dependency Viewer */}
            <div className="border rounded-lg p-4 mb-6">
                <h3 className="font-medium mb-2">Add Dependencies / Dependents</h3>
                <DependenciesTable
                    nodeId={node_id}
                    className="w-full"
                />
            </div>

            {/* Answer options */}
            <div className="mt-6 flex flex-wrap gap-2 justify-center">
                {/* For now, we'll just offer the Skip option since the other options require node selection UI */}
                <Button
                    color="gray"
                    onClick={() => onAnswerSelected("Skip")}
                    className="mr-2"
                >
                    Skip for now
                </Button>
            </div>
        </div>
    );
};

export default OrphanQuestion;
